import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./actions";
import coaches from "./modules/coaches";
import contractsDetails from "./modules/contractsDetails";
import contractsTransactions from "./modules/contractsTransactions";
import spontanrueckzahlung from "./modules/spontanrueckzahlung";
import unwetterwarnungen from "./modules/unwetterwarnungen";
import flexiblelife from "./modules/flexiblelife";
import fonds from "./modules/fonds";
import postbox from "./modules/postbox";
import user from "./modules/user";
import kreditcheckliste from "./modules/kreditcheckliste";
import dokbox from "./modules/dokbox";
import slidesConfig from "./configs/slidesConfig";
import profileConfig from "./configs/profileConfig";
import motivesConfig from "./configs/motivesConfig";
import PageLinkConfig from "./configs/PageLinkConfig";
import contractsConfig from "./configs/contractsConfig";
import fondsConfig from "./configs/fondsConfig";
import vollwert from "./modules/vollwert";
import biketrax from "./modules/biketrax";
import my21 from "./modules/my21";
import createCache from "vuex-cache";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createCache({ timeout: 5000 * 60 })],
    modules: {
        coaches,
        contractsDetails,
        spontanrueckzahlung,
        unwetterwarnungen,
        flexiblelife,
        fonds,
        postbox,
        user,
        kreditcheckliste,
        dokbox,
        slidesConfig,
        contractsTransactions,
        profileConfig,
        motivesConfig,
        PageLinkConfig,
        contractsConfig,
        fondsConfig,
        vollwert,
        biketrax,
        my21,
    },
    state: {
        loading: false,
        loadingCount: 0,
        loadingSpinnerDuration: 20 * 1000,
        error: false,
        errors: {},
        errorMessage: "",
        contracts: {},
        checklists: {},
        isLoggedIn: false,
        baseurl: "",
        galleryIndex: null,
        galleryToken: "",
        resetSchadensmeldungFormData: false,
        pushToken: "",
        askForRating: false,
        showTabBar: true,
        nativeEnvironment: "production",
        developmentLogs: [],
        afterLoginLink: "",
    },
    getters: {
        motiveWorlds: (state) => {
            var motiveWorlds = {};
            for (let contractKey in state.contracts) {
                for (let motivesKey in state.contracts[contractKey].Motives) {
                    var subMotiveWorld =
                        state.contracts[contractKey].Motives[motivesKey];
                    var contractId = state.contracts[contractKey].ContractId;
                    if (!(motivesKey in motiveWorlds)) {
                        motiveWorlds[motivesKey] = {
                            [subMotiveWorld]: [],
                        };
                    } else if (!(subMotiveWorld in motiveWorlds[motivesKey])) {
                        motiveWorlds[motivesKey][subMotiveWorld] = [];
                    }
                    motiveWorlds[motivesKey][subMotiveWorld].push(contractId);
                }
            }
            return motiveWorlds;
        },
        motives: (state) => {
            var motives = {};
            for (let contractKey in state.contracts) {
                for (let motivesKey in state.contracts[contractKey].Motives) {
                    var subMotiveWorld =
                        state.contracts[contractKey].Motives[motivesKey];
                    var contractId = state.contracts[contractKey].ContractId;
                    if (!(subMotiveWorld in motives)) {
                        motives[subMotiveWorld] = [];
                    }
                    motives[subMotiveWorld].push(contractId);
                }
            }
            return motives;
        },
        schadensmeldungen: (state) => {
            let schadensmeldungen = {
                SchadensmeldungKfz: [],
                SchadensmeldungHaushalt: [],
                SchadensmeldungSach: [],
                SchadensmeldungRecht: [],
                SchadensmeldungRechtKfz: [],
                SchadensmeldungRechtSach: [],
            };
            for (let key in schadensmeldungen) {
                for (let contractKey in state.contracts) {
                    if (key in state.contracts[contractKey].Features) {
                        schadensmeldungen[key].push(contractKey);
                    }
                }
            }
            schadensmeldungen.SchadensmeldungRecht = [
                ...new Set([
                    ...schadensmeldungen.SchadensmeldungRecht,
                    ...schadensmeldungen.SchadensmeldungRechtKfz,
                    ...schadensmeldungen.SchadensmeldungRechtSach,
                ]),
            ];
            return schadensmeldungen;
        },
    },
    mutations: mutations,
    actions: actions,
});
